export default __webpack_public_path__ + "static/media/reporting_analytics_module_preview.148c45cc.png";